import { createClient } from '@supabase/supabase-js';

// Rigrestr Supabase Configuration
// Using environment variables for security
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://rdeurpovwtowqcidwlma.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJkZXVycG92d3Rvd3FjaWR3bG1hIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAyMDEwMTUsImV4cCI6MjA3NTc3NzAxNX0.Sf1EaSjVLdpJ1-OtdMfEXQywxZMwFg20zrsuwa_bspI';

// Validate configuration
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Missing Supabase configuration. Please check your .env file.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});
